firebird.factory('videoLayoutMoveService', [
    'configService',
    function (configService) {
        var service = {
            initialize: initialize
        };

        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            self.initLayoutMove = initLayoutMove;

            // whether video boxes in layout can be dragged to move. Modify in URL param or user pair.
            self.layoutMove = false;
        }

        // update from config
        function initLayoutMove() {
            // layout move, from URL param, fallback to user pair.
            var layoutMove = configService.getValue('layoutMove');
            self.layoutMove = layoutMove == 'true';
        }
    }
]);
